import { Modal } from 'antd';
import styled from 'styled-components';

export const InventoryReportWrapper = styled.div`
  padding: 2rem;
  display: flex;
  flex-direction: column;
  width: 100%;

  .inventory-report_header {
    position: relative;
    display: flex;
    align-items: center;
    margin-bottom: 24px;

    button.inventory-report_back-btn {
      display: flex;
      align-items: center;
      gap: 6px;
      background: #edeff1;
      border: none;
      border-radius: 8px;
      height: 40px;
      padding: 0 16px;
      cursor: pointer;
      font-size: var(--font-size-base);
      font-weight: var(--font-medium);
      color: var(--color-text-primary, #111827);
      transition: background 0.2s;
      position: relative;
      z-index: 1;

      &:hover {
        background: #dde1e5;
      }
    }

    h1 {
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      text-align: center;
      white-space: nowrap;
      font-weight: var(--font-bold);
      line-height: 46px;
      margin: 0;
    }
  }

  .inventory-report_section {
    border: 1px solid var(--color-border-primary, #e5e7eb);
    border-radius: 8px;
    padding: 20px 24px;
    margin-bottom: 20px;

    .inventory-report_section-title {
      font-size: var(--font-size-sm);
      font-weight: var(--font-medium);
      color: var(--color-text-secondary, #6b7280);
      margin-bottom: 16px;
      padding-bottom: 8px;
      border-bottom: 1px solid var(--color-border-primary, #e5e7eb);
    }
  }

  .inventory-report_conditions-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 16px 32px;
    max-width: 720px;
  }

  .inventory-report_store-readonly {
    background: #f3f4f6;
    border: 1px solid var(--color-border-primary, #e5e7eb);
    border-radius: 6px;
    padding: 0 14px;
    height: 40px;
    display: flex;
    align-items: center;
    font-size: var(--font-size-base);
    font-weight: var(--font-medium);
    color: var(--color-text-primary, #111827);
  }

  .inventory-report_header-note {
    text-align: right;
    font-weight: var(--font-bold);
    margin-bottom: 12px;
    color: var(--color-text-primary, #111827);
  }

  .inventory-report_ellipsis {
    display: inline-block;
    max-width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .inventory-report_footer {
    display: flex;
    justify-content: flex-end;
    gap: 12px;
    padding-top: 8px;

    .ant-btn {
      height: 48px;
      min-width: 140px;
      font-weight: var(--font-bold);
      border-radius: 8px;
    }

    .ant-btn-default {
      color: var(--color-primary, #1677ff);
      border-color: var(--color-primary, #1677ff);
    }

    .ant-btn-primary {
      background-color: var(--color-primary, #1677ff);
      border-color: var(--color-primary, #1677ff);
    }
  }

  .ant-form-item {
    margin-bottom: 0;

    .ant-form-item-label label {
      font-weight: var(--font-medium);
    }

    .ant-select-selector {
      border-radius: 6px;
    }
  }
`;

export const InventoryOutputDialogWrapper = styled(Modal)`
  .ant-modal-content {
    padding: 0;
    border-radius: 12px;
    box-shadow: 0px 2px 8px 0px rgba(5, 40, 97, 0.12);
  }

  .ant-modal-header {
    padding: 16px 24px;
    border-bottom: 1px solid var(--color-border-primary, #e5e7eb);
    margin-bottom: 0;

    .ant-modal-title {
      font-weight: var(--font-bold);
      font-size: var(--font-size-base);
    }
  }

  .ant-modal-body {
    padding: 20px 24px;
  }

  .ant-modal-footer {
    display: flex;
    justify-content: flex-end;
    gap: 12px;
    padding: 12px 24px 20px;
    margin-top: 0;
    border-top: 1px solid var(--color-border-primary, #e5e7eb);

    .ant-btn {
      min-width: 120px;
      height: 44px;
      font-weight: var(--font-bold);
      border-radius: 8px;
      margin-inline-start: 0 !important;
    }

    .ant-btn-default {
      color: var(--color-primary, #1677ff);
      border-color: var(--color-primary, #1677ff);
    }
  }

  .output-confirm_message {
    margin-bottom: 16px;
    font-size: var(--font-size-base);
    color: var(--color-text-primary, #111827);
  }

  .ant-table-wrapper {
    border: 1px solid var(--color-border-primary, #e5e7eb);
    border-radius: 8px;
    overflow: hidden;
  }
`;
